import { createFileRoute, notFound } from '@tanstack/react-router'
import * as v from 'valibot'

import { FEATURE_LEARNGROUP } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import Learngroup from '@/learngroup/components/Learngroup'

const learngroupSearchSchema = v.object({
  learngroup: v.optional(
    v.picklist(['teammates', 'name', 'edit', 'resend', 'accept', 'deny']),
  ),
})

export const Route = createFileRoute('/_learning/_company/learngroup')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-learngroup',
        }),
      },
    ],
  }),
  validateSearch: learngroupSearchSchema,
  beforeLoad: ({ context }) => {
    if (!context.user?.features.includes(FEATURE_LEARNGROUP)) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Learngroup />
}
